import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { pluck } from 'rxjs/operators';
const addSupplyCategoryMutation = gql`mutation addSupplyCategory($supplyCategory: supply_categories_insert_input!){
  insert_supply_categories_one(object: $supplyCategory){
    id
    name
    created_at
    updated_at
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class AddSupplyCategoryService {

  constructor(
    private apollo: Apollo
  ) { }

  addSupplyCategory(supplyCategory: any){
    return this.apollo.use('external').mutate({
      mutation: addSupplyCategoryMutation,
      variables: {
        supplyCategory
      }
    }).pipe(pluck('data', 'insert_supply_categories_one')).toPromise();
  }
}
